import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from "../../../mixin/mixin.js";
import Vue from "vue";
import VueExcelEditor from "vue-excel-editor";
Vue.use(VueExcelEditor);

export default {
  name: 'loteEquipoPagado',
  mixins: [mixx],
  data() {
    return {
      msg: '-',
      loading: false,
      ventast_tabla: 0,
      tbv: null,
      f_c: {
        desde: this.date_rest(this.currentdate(), -10),
        hasta: this.currentdate()
      }
    }
  },
  mounted() {
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    $(".box").boxWidget();
    this.tbv = $("#ventas").DataTable({
      paging: true,
      lengthChange: true,
      searching: true,
      ordering: true,
      info: true,
      order: [],
      autoWidth: true,
      orderCellsTop: true,
      fixedHeader: true,
      rowCallback: function (row, data, index) { }
    });
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  },
  computed: {
    reporte: function () {
      return (
        "/reportes/lote/equipo?dsis=" + window.sssdi +
        "&desde=" +
        this.f_c.desde +
        "&hasta=" +
        this.f_c.hasta +
        "&filt=" +
        this.f_c.estado
      );
    }
  },
  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.$http
        .post(
          "/reportes/lote/equipo", this.f_c)
        .then(response => {
          this.ventast_tabla = 0;

          response.data.data.forEach(element => {
            this.ventast_tabla += parseFloat(element[7]);
            element[7] = this.num_to_many(element[7]);
            element[8] = this.num_to_many(element[8]);
            this.tbv.row.add(element);
          });

          this.ventast_tabla = this.num_to_many(
            this.ventast_tabla.toFixed(2)
          );
          this.tbv.draw();
          this.loading = false;
        });
    },
  


  }
}



// WEBPACK FOOTER //
// ./src/components/reportes/loteEquipoPagado/index.js